export default __webpack_public_path__ + "img/fpoduSOD.b10d21dd.svg";